import { ButtonDropdown, Filter, Filters, Search, Sort, TooltipV2 } from '@cimplico/components';
import { useNavigate } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';
import { useIsActiveSubscription } from '../../hooks/use-is-active-subscription';
import { useIsFirmRole } from '../../hooks/use-is-firm-role';

const sortOptions = [
    { id: 'email', label: 'Email' },
    { id: 'firstName', label: 'First Name' },
    { id: 'lastName', label: 'Last Name' },
    { id: 'updatedAt', label: 'Last Updated' },
    { id: 'role', label: 'Role' },
];

const filterOptions: Filters = [
    { type: 'date', title: 'Last Updated', option: {}, id: 'updatedAt' },
    {
        type: 'checkbox',
        title: 'Role',
        options: [
            { active: false, label: 'User', value: 'USER' },
            { active: false, label: 'Manager', value: 'MANAGER' },
            { active: false, label: 'Admin', value: 'ADMIN' },
            { active: false, label: 'External User', value: 'EXTERNAL_USER' },
        ],
        id: 'role',
    },
];

type UserPrimaryActionsProps = {
    onFilterChange: (qs: string) => void;
    onSearchChange: (qs: string) => void;
    onSortChange: (qs: string) => void;
};

function UserPrimaryActions({ onFilterChange, onSearchChange, onSortChange }: UserPrimaryActionsProps): JSX.Element {
    const navigate = useNavigate();
    const { isManager, isAdmin } = useIsFirmRole();
    const { integrations } = useFirmContext();
    const { shortId } = useFirmContext();
    const activeSubscription = useIsActiveSubscription();
    const fyiIntegration = Boolean(integrations.fyi?.cabinet);

    const roleCanInvite = isAdmin || isManager;

    function redirectToNewUser(provider?: string): void {
        if (provider) {
            navigate(`/${shortId}/users/new?provider=${provider}`);
        } else {
            navigate(`/${shortId}/users/new`);
        }
    }

    return (
        <div className="flex gap-4 items-center">
            <Filter size="small" onChange={({ queryString }): void => onFilterChange(queryString)} filters={filterOptions} enableV2Query />
            <div className="grow">
                <Search size="small" onChange={onSearchChange} placeholder="Search..." />
            </div>
            <div className="flex gap-4 ml-auto">
                <Sort
                    size="small"
                    onChange={({ queryString }): void => onSortChange(queryString)}
                    sortOptions={sortOptions}
                    enableV2Query
                />
                <TooltipV2 message="This requires an admin or manager role." disabled={roleCanInvite} position="left">
                    <ButtonDropdown
                        variant="primary"
                        label="Add users"
                        onClick={(): void => redirectToNewUser()}
                        size="xs"
                        disabled={!activeSubscription || !roleCanInvite}
                    >
                        {fyiIntegration && (
                            <ButtonDropdown.SecondaryAction
                                label="Add from FYI"
                                onClick={(): void => redirectToNewUser('fyi')}
                                disabled={!activeSubscription}
                            />
                        )}
                    </ButtonDropdown>
                </TooltipV2>
            </div>
        </div>
    );
}
export default UserPrimaryActions;
